export function getAuthenticatedTicketUser(user) {
  const id = Number(user?.id);
  const nombre = typeof user?.nombre === "string" ? user.nombre.trim() : "";

  if (!Number.isInteger(id) || id <= 0 || !nombre) {
    throw new Error("No se pudo identificar al usuario autenticado. Inicie sesión nuevamente.");
  }

  return { id, nombre };
}
